export function downloadFileFromURL(url, name = 'download') {
    let link: any = document.createElement('a');
    link.href = `${url}`;
    link.download = name;
    link.target = '_blank';
    link.rel = 'noopener';
    link.click();
    link.remove();
    link = null;
    return link;
}
